<script lang="ts">
	import type { BadgeColor } from '$lib/components/atoms/badge/types';
	import Badge from '$lib/components/atoms/badge/Badge.svelte';
	import DatasheetDetailBlock from '$lib/components/pois/datasheet/detail/DatasheetDetailBlock.svelte';
	import * as m from '$paraglide/messages';

	interface Props {
		strongPoints: string[];
		color: BadgeColor;
	}

	const { strongPoints = [], color }: Props = $props();
</script>

<DatasheetDetailBlock title={m.poi_datasheet__strong_points()}>
	<div class="flex flex-row flex-wrap gap-1">
		{#each strongPoints as strongPoint (strongPoint)}
			<Badge text={strongPoint} {color} />
		{/each}
	</div>
</DatasheetDetailBlock>
